import React, { useEffect, useRef } from 'react';
import { Input } from 'reactstrap';
import PencilIcon from 'mdi-react/PencilOutlineIcon';
import DeleteIcon from 'mdi-react/DeleteOutlineIcon';
import Menu from 'mdi-react/MenuIcon';
import Checkbox from 'rc-checkbox';

const AppointmentTypeItem = ({
  type,
  provided,
  toggleCheck,
  editingId,
  newTypeName,
  handleEditChange,
  handleEdit,
  handleEditSave,
  handleDelete,
  setNewTypeName,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (editingId === type._id && inputRef.current) {
      inputRef.current.focus();
      const length = inputRef.current.value?.length || 0;
      inputRef.current.setSelectionRange(length, length);
    }
  }, [editingId, type._id]);

  return (
    <div
      className="d-flex align-items-center justify-content-between border-bottom rounded p-2 mb-2"
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div
        {...provided.dragHandleProps}
        style={{ cursor: 'grab', marginRight: '10px' }}
      >
        <Menu />
      </div>
      <Checkbox
        checked={type.checked}
        onChange={() => toggleCheck(type._id)}
        className="me-2"
      />
      {editingId === type._id ? (
        <Input
          innerRef={inputRef}
          type="text"
          value={typeof newTypeName === 'string' ? newTypeName : ''}
          onChange={handleEditChange}
          onBlur={() => handleEditSave(type._id)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleEditSave(type._id);
          }}
        />
      ) : (
        <div className="flex-grow-1 appointment-title">{type.title}</div>
      )}
      {!!type.isCustom && (
        <span className="badge bg-secondary mx-2">Custom</span>
      )}
      {type.isCustom && type?.editable && (
        <>
          <PencilIcon
            size={18}
            onClick={() => {
              setNewTypeName(type.title);
              handleEdit(type._id);
            }}
            style={{
              cursor: 'pointer',
              marginRight: 8,
              width: 18,
              height: 18,
              flexShrink: 0,
            }}
          />
          <DeleteIcon
            size={18}
            onClick={() => handleDelete(type._id)}
            style={{
              cursor: 'pointer',
              marginRight: 8,
              width: 18,
              height: 18,
              flexShrink: 0,
            }}
          />
        </>
      )}
    </div>
  );
};

export default AppointmentTypeItem;
